"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenBonusCheckOptions = void 0;
var TokenBonusCheckOptions;
(function (TokenBonusCheckOptions) {
    TokenBonusCheckOptions[TokenBonusCheckOptions["None"] = 0] = "None";
    TokenBonusCheckOptions[TokenBonusCheckOptions["MinimumOdd"] = 1] = "MinimumOdd";
    TokenBonusCheckOptions[TokenBonusCheckOptions["MaximumOdd"] = 2] = "MaximumOdd";
    TokenBonusCheckOptions[TokenBonusCheckOptions["MinimumCombination"] = 4] = "MinimumCombination";
    TokenBonusCheckOptions[TokenBonusCheckOptions["MaximumCombination"] = 8] = "MaximumCombination";
    TokenBonusCheckOptions[TokenBonusCheckOptions["MinimumStake"] = 16] = "MinimumStake";
    TokenBonusCheckOptions[TokenBonusCheckOptions["MaximumStake"] = 32] = "MaximumStake";
    TokenBonusCheckOptions[TokenBonusCheckOptions["GameModeType"] = 64] = "GameModeType";
    TokenBonusCheckOptions[TokenBonusCheckOptions["SportId"] = 128] = "SportId";
    TokenBonusCheckOptions[TokenBonusCheckOptions["LeagueId"] = 256] = "LeagueId";
    TokenBonusCheckOptions[TokenBonusCheckOptions["GameId"] = 512] = "GameId";
    TokenBonusCheckOptions[TokenBonusCheckOptions["MarketId"] = 1024] = "MarketId";
    TokenBonusCheckOptions[TokenBonusCheckOptions["StakeEqualsFreeBetTokenAmount"] = 2048] = "StakeEqualsFreeBetTokenAmount";
    TokenBonusCheckOptions[TokenBonusCheckOptions["ProductType"] = 4096] = "ProductType";
    TokenBonusCheckOptions[TokenBonusCheckOptions["AllChecks"] = 8191] = "AllChecks";
})(TokenBonusCheckOptions = exports.TokenBonusCheckOptions || (exports.TokenBonusCheckOptions = {}));
